export const getQuery = (param) => {
  const data = new URLSearchParams(document.location.search).get(param);
  return data;
};

